import React, { useState, useEffect } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
// import Date from '../../../../Core/Fields/Floating/Date';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

function Tab1({ fullDataState, activityboll, pack_slip,detail }) {
  const [showActivity, setShowActivity] = useState(true);
  const [fields, setFields] = useState({
    orderNo: '' || pack_slip,
    date: '',
    po: '',
    customer: '',
    dueDate: '',
    remarks: '',
    company: '',
    orderType: '',
    test: '',
    source: '',
    billingType: '',
    delivery_note: '',
    from_case_no: '',
    to_case_no: '',
  });

  useEffect(() => {
    const result = fullDataState?.result;
    const updatedFields = {};

    if (result?.name) updatedFields.orderNo = result.name;
    if (result?.from_case_no) updatedFields.from_case_no = result.from_case_no;
    if (result?.to_case_no) updatedFields.to_case_no = result.to_case_no;
    if (result?.delivery_note) {
      updatedFields.delivery_note = result.delivery_note;
    } else if (fullDataState?.docs?.[0]?.name) {
      updatedFields.delivery_note = fullDataState.docs[0].name;
    }
    if (result?.creation) {
      const date = new Date(result.creation);
      updatedFields.date = date.toISOString().split('T')[0];
    }

    if (Object.keys(updatedFields).length > 0) {
      setFields(prev => ({ ...prev, ...updatedFields }));
    }
  }, [fullDataState]);

  const handleChange = (field, value) => {
    setFields({ ...fields, [field]: value });
  };

  return (
    <div
      className="row sidebarbox m-0"
      style={{
        padding: "8px",
        borderRadius: "5px",
        maxHeight: "74vh",
        minHeight: "74vh",
        overflowY: "scroll",

      }}
    >
      <div style={{ maxHeight: "74vh", }}>
        {/* Top Section */}
        <div >
          <div className="d-flex gap-3 mb-2" >
            <div className="col">
              <Input
                id="orderNo"
                label="No."
                value={fields.orderNo}
                onChange={(e) => handleChange('orderNo', e.target.value)}
                style={{ height: '30px' }}
                readOnly
              />
            </div>
            <div className="col">
              <Input
                id="date"
                label="Order Date"
                value={fields.date}
                onChange={(e) => handleChange('date', e.target.value)}
                style={{ height: '30px' }}
                readOnly
              />
            </div>
          </div>
          <div className='mb-3' >
            {/* <Input
              id="delivery_note"
              label="Delivery Note"
              value={fields.delivery_note || '-'}
              readOnly
              style={{ height: '30px', backgroundColor: '#f8f9fa' }}
            /> */}

             <SelectSearch
                      list={detail.deliveryNoteList}
                      label="Select Delivery List No."
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={detail.deliveryNoteId}
                      onChange={(val) => detail.setdeliveryNoteId(val)}
                    /> 
          </div>

          <div className='mb-3'>

            <Input
              id="from_case_no"
              label="From Package No"
              value={fields.from_case_no || '-'}
              readOnly
              style={{ height: '30px', backgroundColor: '#f8f9fa' }}
            />
          </div>
          <div className='mb-3'>

            <Input
              id="to_case_no"
              label="To Package No"
              value={fields.to_case_no || '-'}
              readOnly
              style={{ height: '30px', backgroundColor: '#f8f9fa' }}
            />
          </div>
          <div className='mb-2' >

            <Input
              id="remarks"
              label="Remarks"
              value={fields.remarks}
              readOnly
              style={{ height: '30px', backgroundColor: '#f8f9fa' }}
            />
          </div>


        </div>

        {/* Middle Section */}
        <div >
          <CollapsibleSection title="Package Weight Details">
            {/* Content can be added here if needed */}
          </CollapsibleSection>

          <CollapsibleSection title="Letter Head">
            {/* Content can be added here if needed */}
          </CollapsibleSection>
        </div>

        {/* Activity Section */}
        <div style={{ height: '24vh' }}>
          <div className="col-12">
            <div
              className="py-2 d-flex justify-content-between align-items-center"
              onClick={() => setShowActivity(!showActivity)}
              style={{ cursor: 'pointer' }}
            >
              <p className="firstcolor m-0" style={{ fontWeight: 450, fontSize: '1rem' }}>Activity</p>
              <GetIcon iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"} size={22} />
            </div>

            {showActivity && (
              <VersionHistory
                doctype="Packing Slip"
                docname={pack_slip}
                activityboll={activityboll}
              />
            )}
          </div>
        </div>
      </div>
    </div>

  );
}

export default Tab1;